import Vue from "vue";
import VueRouter from "vue-router";
// import NotFound from "../views/404";
import NProgress from "nprogress"; // 路由守卫
import "nprogress/nprogress.css";

//import BasicLayout from '../Layouts/BasicLayout' ##如果是用import 懒加载 去注册就不要写这个
//import Home from "../views/Home.vue";
//import Statistics from "../views/Statistics.vue";
Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   redirect: "/home",
  // },
  {
    path: "/home",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/home"),
  },
  {
    path: "/geneDetails",
    name: "geneDetails",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/geneDetails"),
  },
  {
    path: "/publications",
    name: "publications",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/publications/publications"
      ),
  },
  {
    path: "/bulkseq",
    name: "bulkseq",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/publications/bulkSeq/bulkGene"
      ),
  },
  {
    path: "/genes",
    name: "genes",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/genes/genemodels"),
  },
  {
    path: "/oncopheno",
    name: "oncopheno",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/cancerphenotypes/oncoPheno"
      ),
  },
  {
    path: "/fclusters",
    name: "fclusters",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/fClusters/functionClusters"
      ),
  },
  {
    path: "/pcDetails",
    name: "pcDetails",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/fClusters/pcDetails/pcDetails"
      ),
  },
  {
    path: "/inhibitor",
    name: "inhibitor",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/target_drug"),
  },
  {
    path: "/drugModelResult",
    name: "drugModelResult",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/drugs/00drugModelResult"
      ),
  },
  {
    path: "/drugGeneResult",
    name: "drugGeneResult",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/drugs/01drugGene"),
  },
  {
    path: "/drugGeneModel",
    name: "drugGeneModel",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/drugs/02drugGeneModel"
      ),
  },
  // {
  //   path: "/drugPCLModel",
  //   name: "drugPCLModel",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "about" */ "../components/drugs/drugPCLModel"
  //     ),
  // },
  {
    path: "/pubdatasets",
    name: "pubdatasets",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/publications/subCom/pubdataset"
      ),
  },
  {
    path: "/scATACseq",
    name: "scATACseq",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/scATACseq/atacSeqDetails.vue"
      ),
  },
  {
    path: "/perturbedgenes",
    name: "perturbedgenes",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/perturbedgene/perturbedgene"
      ),
  },
  {
    path: "/quickSearch",
    name: "quickSearch",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/search_quick"),
  },
  {
    path: "/search",
    name: "Search",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/search"),
  },
  {
    path: "/search_custome",
    name: "search_custome",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/search_custome"),
  },
  // {
  //   path: "/download",
  //   name: "download",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../components/download"),
  // },
  {
    path: "/PGSEA",
    name: "PGSEA",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/scGPEA"),
  },
  {
    path: "/primerFinder",
    name: "primerFinder",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/primerFinder/primerFinder"
      ),
  },
  {
    path: "/DrawCorrHeatmap",
    name: "DrawCorrHeatmap",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/fClusters/subcoms/divCor"
      ),
  },
  {
    path: "/help",
    name: "help",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/help"),
  },
  {
    path: "/cancers",
    name: "cancers",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/cancers/genemodels"
      ),
  },
  {
    path: "/download",
    name: "download",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/statistics"),
  },
  {
    path: "*",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/home"),
  },
];

const router = new VueRouter({
  //mode: "history",
  base: "/perturbdb", //开发参数  上传到网站上的目录
  //base: "./", //打包参数
  routes,
});

//路由守卫项
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
